// Order status enum used by the dispatch FE filter pills + status badges.
// The BE column is `orders.status` of type `order_status`; this enum
// mirrors that. Keep in sync with migration 030_orders.sql (+ the
// 'sorting'/'dispatch' split in 106_order_status_sorting_dispatch.sql —
// 'processing' is retired and never returned by the BE after backfill;
// 'exchange' from 263_order_status_exchange.sql: a returns-portal exchange
// order waiting, stock held, for the customer's return).

export type OrderStatus =
    | "unfulfilled"
    | "picking"
    | "picked"
    | "sorting"
    | "dispatch"
    | "fulfilled"
    | "flagged"
    | "partially_refunded"
    | "refunded"
    | "cancelled"
    | "on_hold"
    | "exchange"
    | "consolidated";

export const ALL_ORDER_STATUSES: OrderStatus[] = [
    "unfulfilled",
    "picking",
    "picked",
    "sorting",
    "dispatch",
    "fulfilled",
    "flagged",
    "partially_refunded",
    "refunded",
    "cancelled",
    "on_hold",
    "exchange",
    "consolidated",
];
